import { PrintOutlined, ReceiptLongOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { ESTADO_IMPRESION } from "../impresion";
import { describirEstadoImpresion, puedeSolicitar } from "../impresion/etiquetas";

const COLOR_POR_TONO = {
  neutro: "#64748B",
  ok: "#18735F",
  error: "#B3261E",
  alerta: "#9A6209",
};

// Una ranura de impresión (primer papel o comanda) con su estado honesto y la
// acción manual siempre disponible cuando hay algo que imprimir.
export default function DocumentoImpresionCard({
  titulo,
  estado,
  error,
  icono = "factura",
  onImprimir,
  testId,
}) {
  const descripcion = describirEstadoImpresion(estado);
  const Icono = icono === "comanda" ? PrintOutlined : ReceiptLongOutlined;
  const habilitado = Boolean(onImprimir) && puedeSolicitar(estado);
  const etiquetaBoton = estado === ESTADO_IMPRESION.SIN_SOLICITAR ? "Imprimir" : "Reimprimir";

  return (
    <Box
      data-testid={testId}
      data-estado={estado}
      sx={{
        p: 2,
        border: "1px solid #DCE3EC",
        borderRadius: "14px",
        textAlign: "left",
        display: "flex",
        gap: 1.25,
        alignItems: "center",
      }}
    >
      <Icono sx={{ color: "#2C3087" }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 900, fontSize: 13 }}>{titulo}</Typography>
        <Typography sx={{ color: COLOR_POR_TONO[descripcion.tono] || COLOR_POR_TONO.neutro, fontSize: 11, fontWeight: 700 }}>
          {descripcion.titulo}
        </Typography>
        <Typography sx={{ color: "#64748B", fontSize: 10.5 }}>{error || descripcion.detalle}</Typography>
      </Box>
      <Button
        size="small"
        variant="outlined"
        disabled={!habilitado}
        onClick={onImprimir}
        sx={{
          borderRadius: "10px",
          borderColor: "#2C3087",
          color: "#2C3087",
          textTransform: "none",
          fontWeight: 800,
          fontSize: 11,
          px: 1.25,
          minWidth: 0,
          whiteSpace: "nowrap",
          "&:hover": { borderColor: "#22266F", bgcolor: "#F3F2FF", color: "#22266F", opacity: 1 },
        }}
      >
        {etiquetaBoton}
      </Button>
    </Box>
  );
}

DocumentoImpresionCard.propTypes = {
  titulo: PropTypes.string.isRequired,
  estado: PropTypes.string.isRequired,
  error: PropTypes.string,
  icono: PropTypes.oneOf(["factura", "comanda"]),
  onImprimir: PropTypes.func,
  testId: PropTypes.string,
};
